import { createAsyncThunk } from "@reduxjs/toolkit";

import { instance } from "./../../axios/axios";

export const upload = createAsyncThunk(
  "uploadDocs/upload",
  async (
    {
      currentMileage,
      registrationExpiryDate,
      forNextOilChange,
      truckNumber,
      assignTechToTruck,
      signatureImageData,
      taskType,
      taskTypeID,
      recID,
      taskStatus,
      internalNotes,
      fileUpload,
      techtrainingdate,
      techtrainingtime,
      techtraininglocation,
      notes,
      submitMode,
      techEmployeeId,
      licensenumber,
      truckid,
      avgDailyRevenue,
      taskNumber,
      taskCausedBy,
      taskStartDate,
      typeOfRequest,
      metadata,
      completedTaskManager
    },
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();
      const token = state.auth.token;

      // const formData = new FormData();
      // formData.append("truckNumber", truckNumber);
      // formData.append("licensenumber", licensenumber);
      // formData.append("techEmployeeId", techEmployeeId);
      // formData.append("signatureImageData", signatureImageData);
      // formData.append("taskType", taskType);
      // formData.append("taskTypeID", taskTypeID);
      // formData.append("recID", recID);
      // formData.append("assignTechToTruck", assignTechToTruck);
      // formData.append("taskStatus", taskStatus);
      // formData.append("internalNotes", internalNotes);
      // formData.append("fileUpload", fileUpload);
      // formData.append("currentMileage", currentMileage);
      // formData.append("registrationExpiryDate", registrationExpiryDate);
      // formData.append("forNextOilChange", forNextOilChange);
      // formData.append("techtrainingdate", techtrainingdate);
      // formData.append("techtrainingtime", techtrainingtime);
      // formData.append("techtraininglocation", techtraininglocation);
      // formData.append("notes", notes);
      // formData.append("submitMode", submitMode);
      // formData.append("truckid", truckid);

      const obj = {
        currentMileage,
        registrationExpiryDate,
        completedTaskManager,
        forNextOilChange,
        truckNumber,
        assignTechToTruck,
        signatureImageData,
        taskType,
        taskTypeID,
        recID,
        taskStatus,
        internalNotes,
        fileUpload,
        techtrainingdate,
        techtrainingtime,
        techtraininglocation,
        notes,
        submitMode,
        techEmployeeId,
        licensenumber,
        truckid,
        avgDailyRevenue,
        taskNumber,
        taskCausedBy,
        taskStartDate,
        typeOfRequest,
        metadata
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await instance.post(
        "/uploadDocs/portal/upload",
        obj,
        config
      );

      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const generateUrlUpload = createAsyncThunk(
  "uploadDocs/generateUrlUpload",
  async ({ fileName }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await instance.post(
        "/uploadDocs/portal/generate-url-upload",
        { fileName },
        config
      );

      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const uploadFilesURL = createAsyncThunk(
  "uploadDocs/uploadFiles",
  async ({ formdata, url }, { rejectWithValue }) => {
    try {
      // const state = getState();
      // const token = state.auth.token;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          // Authorization: `Bearer ${token}`,
        },
      };

      const { data, status } = await instance.post(`${url}`, formdata, config);

      return { data, status };
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


export const uploadTechnicianCertificate = createAsyncThunk(
  "uploadDocs/uploadTechnicianCertificate",
  async (formdata, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data, status, message } = await instance.post(`/uploadDocs/portal/certificateupload`, formdata, config);

      return { data, status, message };
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


export const createRecords = createAsyncThunk(
  "task/createRecords",
  async (formData, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(`/uploadDocs/portal/create-record`, formData, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

